import { Map, fromJS } from 'immutable';

import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

const initialState = Map();

const openGraphReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE:
            return initialState;
        case Actions.RESULT_OPEN_GRAPH_DATA: {
            const urlKeys = action.urlList.reduce(
                (acc, url) => acc.set(url, Map()),
                Map(),
            );
            const dataMap = listToMap(fromJS(action.data), (openGraphDTO) =>
                openGraphDTO.get('urlString'),
            );
            return state.merge(urlKeys).merge(dataMap);
        }
        default:
            return state;
    }
};

export default openGraphReducer;
